<template>
  <div class="kt-notes__item" :class="{ 'slideDownDay': isSlideDownDay }" v-if="data.status !== -1">
    <div class="kt-notes__media">
      <h3 class="kt-notes__user kt-font-light kt-font-boldest kt-bg-danger">{{ data.startday }}</h3>
    </div>
    <div class="kt-notes__content">
      <span
        class="kt-notes__body"
        :class="{ 'isEditing': isEditing, 'isANewDay': data.isANewDay, 'isHighlighted': isHighlighted }">

        <div class="row mt-2 mb-2">
          <div class="col-12 col-md-4 pt-1 TabItineraryItem-image" v-if="data">
            <ImagePicker
              :isDuplicated="data.image_duplicated"
              :imageUrl="data.url_image"
              :isEditing="isEditing"
              :total="totalImages"
              :images="images"
              :countries="countries"
              :isSearching="isImagePickerSearching"
              :defaultParams="defaultImagePickerParams"
              :disableButton="isSaving"
              @onSearch="onImagePickerSearch"
              @onSelectImage="onImagePickerSelectImage" />
          </div>
          <div class="col-12 col-md-8 pr-5 position-relative itinerary-days-text" :id="`day_${order}`">
            <div class="TabItineraryItem--group">
              <button
                  type="button"
                  data-toggle="tooltip" title="Add a new day above it"
                  class="TabItineraryItem--addabove btn btn-md text-danger pt-1"
                  :class="{ 'disabledbtn': isCompletedQuote && !isSalesFlyerSourceType && !isGuestDocSourceType }"
                  :disabled="isSaving || (isCompletedQuote && !isSalesFlyerSourceType && !isGuestDocSourceType)"
                  @click.prevent="addDayAbove"
                  v-if="!isEditing && showAddANewDayAbove">
                  <font-awesome-icon class="mr-1" :icon="['fas', 'plus-circle']" />Add a day</button>
              <button
                data-toggle="tooltip" title="Edit Day information"
                type="button"
                class="TabItineraryItem--edit text-danger"
                :class="{ 'disabled': isCompletedQuote && !isGuestDocSourceType && !isSalesFlyerSourceType }"
                :disabled="isSaving || (isCompletedQuote && !isGuestDocSourceType && !isSalesFlyerSourceType)"
                @click.prevent="toggleEditingBoxes(data, order)"
                v-if="!isEditing">
                <font-awesome-icon :icon="['fas', 'pen']" size="lg" /></button>
              <button
                type="button"
                class="TabItineraryItem--edit text-danger"
                :disabled="isSaving"
                @click.prevent="cancelEditingBoxes(order)"
                v-if="isEditing">
                <font-awesome-icon :icon="['fas', 'times']" size="lg" /></button>
              </div>
            <h4 class="my-0 text-uppercase fw-600 text-dark titleStepDay">Day {{ data.startday }}</h4>

            <div class="py-1">
              <h4 class="fw-600 text-danger TabItineraryItem-title" v-if="!isEditing" v-html="data.title"></h4>
              <BaseInputForm
                v-else
                autofocus
                :disabled="isSaving"
                type="text"
                class="dayItineraryTitle"
                placeholder="Itinerary title"
                v-model="$v.itineraryDay.title.$model"
                @blur="$v.itineraryDay.title.$touch()"
                :validator="$v.itineraryDay.title" />
            </div>

            <h6 class="my-0 pb-1 fw-600 d-flex align-items-center itinerary-days">
              <div class="pr-1  dateDay">
                <font-awesome-icon :icon="['fas', 'calendar-alt']" />
                {{ data.startdate | custom-date }}
              </div>
              <div class="pl-2 TabItineraryItem-locations flex-fill">
                <span class="px-2">
                  <font-awesome-icon :icon="['fas', 'map-marker-alt']" />
                </span>
                <div class="TabItineraryItem-locations--tags pr-1" v-if="!isEditing">
                  <span>{{ showAvaliableLocations(data.locations) | custom-join('name') }}</span>
                  <span v-if="data.isANewDay || !data.locations">Location, Country</span>
                </div>
                <Multiselect
                  v-else
                  :disabled="isSaving"
                  v-model="itineraryDay.locations"
                  :id="`ajax_locations_${data.id}`"
                  label="name"
                  track-by="id"
                  placeholder="Type to search"
                  open-direction="bottom"
                  :options="locations"
                  :multiple="true"
                  :searchable="true"
                  :allowEmpty="true"
                  :loading="isLoading"
                  :internal-search="false"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :options-limit="300"
                  :limit="10"
                  :limit-text="limitText"
                  :max-height="200"
                  :show-no-results="false"
                  :hide-selected="true"
                  @search-change="searchLocations"
                  @select="addLocation"
                  @remove="removeLocation">
                  <template
                    slot="tag"
                    slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span >{{ option.name }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="itineraryDay.locations"
                      @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                </Multiselect>
              </div>
            </h6>

            <div class="mt-3 ck-editor-itinerary">
              <p
                class="lead mt-3 TabItineraryItem-textday"
                v-if="data.textday && data.textday[0] && !isEditing"
                v-html="data.textday[0].textday"></p>
               <p class="lead mt-3 TabItineraryItem-textday" v-if="!data.textday && !isEditing">&nbsp;✍&nbsp;</p>
              <div class="TabItineraryItem-textday isANewDay-textday" v-if="data.isANewDay && !isEditing">&nbsp;✍&nbsp;</div>
              <Editor
                v-if="isEditing"
                :disabled="isSaving"
                :height="150"
                v-model="$v.itineraryDay.textday.$model"
                @blur="$v.itineraryDay.textday.$touch()"
                :validator="$v.itineraryDay.textday" />
            </div>

            <div class="mt-3">
              <div class="mb-2">
                <strong  v-if="data.meals || isEditing" class="text-uppercase mr-2">Meal(s):</strong>
                <font-awesome-icon class="mr-1 custom__add" :icon="['fas', 'plus-circle']" @click="addMeal" v-show="isEditing"/>
                <span class="fw-500" v-if="!isEditing && data.meals">
                  {{ filterMealsByStatus(data.meals) }}
                </span>
                <div v-else class="dayItineraryMeals">
                  <div v-for="(meal,k) in data.meals" :key="k">
                    <BaseInputForm
                        :value="meal.mealsday"
                        :validator="$v.itineraryDay.meals"
                        :disabled="isSaving"
                        type="text"
                        placeholder="Meal"
                        :id="'meal-'+k"
                        @keyup.enter="saveUpdateMeal($event, meal.id, k)"
                        @change="saveUpdateMeal($event, meal.id, k)"
                        @blur="saveUpdateMeal($event, meal.id, k)"
                        />
                    <i class="custom__remove" 
                        @click="removeMeal(meal.id,k)"
                        >❌</i>
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center mb-2 hotels-content" v-if="data.accommodation || isEditing">
                <strong class="text-uppercase pr-2">Hotel(s):</strong>
                <span class="TabItineraryItem-accommodation fw-500 pr-2" v-if="!isEditing" v-html="data.accommodation"></span>
                <BaseInputForm
                  v-else
                  autofocus
                  :disabled="isSaving"
                  type="text"
                  class="dayItineraryAccommodation"
                  placeholder="Hotel(s)"
                  v-model="$v.itineraryDay.accommodation.$model"
                  @blur="$v.itineraryDay.accommodation.$touch()"
                  :validator="$v.itineraryDay.accommodation" />
              </div>
            </div>

            <div class="d-flex justify-content-end align-items-center mt-2 TabItineraryItem--actions" v-if="!isEditing">
              <button
                type="button"
                data-toggle="tooltip" title="Add a new day below it"
                class="btn btn-md text-danger"
                :class="{ 'disabledbtn': isCompletedQuote && !isSalesFlyerSourceType && !isGuestDocSourceType }"
                :disabled="isSaving || (isCompletedQuote && !isSalesFlyerSourceType && !isGuestDocSourceType)"
                @click.prevent="addDayBelow">
                <font-awesome-icon class="mr-1" :icon="['fas', 'plus-circle']" />Add a day</button>
              <button
                type="button"
                data-toggle="tooltip" title="Change the position of this day"
                class="btn btn-md text-danger"
                :class="{ 'disabledbtn': isCompletedQuote && !isGuestDocSourceType }"
                :disabled="isSaving || (isCompletedQuote && !isGuestDocSourceType)"
                @click.prevent="reorderDay({ order, data})">
                <font-awesome-icon class="mr-1" :icon="['fas', 'sort']" />Re-order</button>
              <button
                type="button"
                data-toggle="tooltip" title="Replace this day with another"
                class="btn btn-md text-danger"
                :class="{ 'disabledbtn': isCompletedQuote && !isGuestDocSourceType }"
                :disabled="isSaving || (isCompletedQuote && !isGuestDocSourceType)"
                v-if="!data.isANewDay"
                @click.prevent="fillDay({ order, data})">
                <font-awesome-icon class="mr-1" :icon="['fas', 'exchange-alt']" />Replace</button>
              <button
                type="button"
                data-toggle="tooltip" title="Select a day to fill it"
                class="btn btn-md text-danger"
                :class="{ 'disabledbtn': isCompletedQuote && !isGuestDocSourceType }"
                :disabled="isSaving || (isCompletedQuote && !isGuestDocSourceType)"
                v-if="data.isANewDay"
                @click.prevent="fillDay({ order, data})">
                <font-awesome-icon class="mr-1" :icon="['fas', 'fill-drip']" />Fill</button>
              <button
                type="button"
                data-toggle="tooltip" title="Add a new day below it"
                class="btn btn-md text-danger"
                :class="{ 'disabledbtn': isCompletedQuote && !isGuestDocSourceType }"
                :disabled="isSaving || (isCompletedQuote && !isGuestDocSourceType)"
                @click.prevent="saveLikeATemplate({ order, data})">
                <font-awesome-icon class="mr-1" :icon="['fas', 'book']" />Save it to Library</button>
            </div>

            <div class="d-flex justify-content-end align-items-center my-2" v-else>
              <button
                type="button"
                style="color:#9B9B9B!important;"
                class="btn btn-md btn-outline-hover-secondary kt-label-font-color-2"
                :class="{ 'disabled': isCompletedQuote && !isGuestDocSourceType }"
                :disabled="isSaving"
                @click.prevent="deleteDay({ order, data})">
                <font-awesome-icon class="mr-2" :icon="['fas', 'trash-alt']" />Delete day</button>
              <button
                type="button"
                class="btn btn-md btn-secondary"
                :disabled="isSaving"
                @click.prevent="saveDay">
                <font-awesome-icon class="mr-1" :icon="['fas', 'spinner']" spin v-if="isSaving" />
                <font-awesome-icon class="mr-1" :icon="['fas', 'check']"  v-if="!isSaving" />
                Done editing</button>
            </div>

          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Editor from '@/components/_shared/Editor.vue'
import ImagePicker from '@/components/_shared/image-picker/ImagePicker.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'TabItineraryItem',
  components: {
    Editor,
    ImagePicker,
    Multiselect
  },
  data () {
    return {
      isEditing: false,
      itineraryDay: {
        id: null,
        title: '',
        locations: [],
        textday: '',
        idimagen: 0,
        accommodation: '',
        meals: [],
        duration: 1
      },
      locations: [],
      meals: [],
      isLoading: false,
      isSaving: false,
      isSlideDownDay: false,
      editingDayOrder: null,
      imageSelected: null,
      images: [],
      totalImages: 0,
      isImagePickerSearching: false,
      backupEditDay: null
    }
  },
  computed: {
    ...mapGetters({
      'opportunity': 'opportunity/opportunity',
      'countries': 'location/countries',
      'getItinerarySourceTypeById': 'opportunity/getItinerarySourceTypeById'
    }),
    defaultImagePickerParams () {
      let defaultCountryLocation = ''
      let defaultCityLocation = ''
      if (
        this.data &&
        this.data.locations &&
        Array.isArray(this.data.locations) &&
        this.data.locations.length > 0 &&
        this.data.locations[0].code) {
        let locationName = this.data.locations[0].name || ''
        let countryName = ''
        let cityName = ''
        let cityCode = ''
        const locationSplitted = locationName.split(' - ')
        if (locationSplitted.length === 2) {
          countryName = locationSplitted[1] // Country name
          cityName = locationSplitted[0] // City name
        }
        if (locationSplitted.length > 2) {
          countryName = locationSplitted[locationSplitted.length - 1] // Country name
          cityName = locationName // City name
        }
        const countryCode = this.data.locations[0].code.split('-')[0]
        defaultCountryLocation = {
          text: countryName,
          value: countryCode
        }
        cityCode = this.data.locations[0].code
        defaultCityLocation = {
          text: cityName,
          value: cityCode
        }
      } else {
        defaultCountryLocation = ''
        defaultCityLocation = ''
      }
      return {
        limit: 21,
        offset: 0,
        w: 150,
        h: 150,
        country: defaultCountryLocation,
        city: defaultCityLocation
      }
    },
    isGuestDocSourceType () {
      return this.itinerarySourceTypeSelected.text === this.getItinerarySourceTypeById('ITP-GUEST').text
    },
    isSalesFlyerSourceType () {
      return this.itinerarySourceTypeSelected.text === this.getItinerarySourceTypeById('ITP-FLYER').text
    }
  },
  validations: {
    itineraryDay: {
      id: { required },
      title: { required },
      locations: [],
      textday: { required },
      idimagen: {},
      accommodation: { required },
      meals: []
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    order: {
      type: Number,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    },
    isHighlighted: {
      type: Boolean,
      default: false
    },
    itinerarySourceTypeSelected: {
      type: Object,
      required: true
    },
    showAddANewDayAbove: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    filterMealsByStatus(meals = []) {
      const filteredMeals = meals.filter(meal => meal.status !== -1);
      return this.getStringMeals(filteredMeals);
    },
    getStringMeals(meals = []) {
      const stringMeals = meals.reduce((acc, meal, ind) => {
        if (ind === meals.length - 1) return acc + meal.mealsday;
        return acc + meal.mealsday + ", ";
      }, "");
      return stringMeals;
    },
    showAvaliableLocations (locations) {
      const locationsAvaliable = []
      if (locations && locations.length) {
        locations.forEach((l) => {
          if (!l.status || l.status !== -1) {
            locationsAvaliable.push(l)
          }
        })
      }
      return locationsAvaliable
    },
    onImagePickerSearch (params) {
      this.isImagePickerSearching = true
      if (params.country) {
        this.$store.dispatch('asset/getAssets', params)
          .then(response => {
            this.images = response.asset || [] // Array images
            this.totalImages = response.total
            this.isImagePickerSearching = false
          })
          .catch(error => {
            console.log(error)
            this.isImagePickerSearching = false
            this.totalImages = 0
            this.images = []
          })
      } else {
        this.images = []
        this.totalImages = 0
        this.isImagePickerSearching = false
      }
    },
    onImagePickerSelectImage (imagesSelected) {
      this.itineraryDay.idimagen = imagesSelected.assetId
      this.imageSelected = imagesSelected
    },
    loadDay (day, order) {
      // Note: Add order because I need to use for the endpoint
      let locations = []
      let textday = ''
      let accommodation = ''
      let meals = []
      let duration = 1
      if (day.locations && day.locations.length) {
        day.locations.forEach(l => {
          if (!l.status || l.status !== -1) {
            locations.push({ id: l.id, name: l.name, order: l.order })
          }
        })
      }
      if (day.textday) {
        textday = day.textday[0].textday
      }
      if (day.accommodation) {
        accommodation = day.accommodation
      }
      if (day.meals) {
        meals = day.meals
      }
      if (day.duration) {
        duration = day.duration
      }
      this.$v.itineraryDay.$model = {
        id: day.id,
        title: day.title,
        idimagen: day.idimagen,
        locations,
        textday,
        accommodation,
        meals,
        duration
      }
    },
    scrollTo (order) {
      this.$scrollTo(`#day_${order}`, { duration: 800, offset: -133 })
    },
    toggleBox (value) {
      this.isEditing = value
    },
    backupDay (day) {
      const clone = JSON.parse(JSON.stringify(day))
      this.backupEditDay = clone
    },
    restoreDay (order) {
      const payload = {
        index: order,
        day: this.backupEditDay
      }
      this.$store.commit('opportunity/TEMP_FILL_DAY_REGULAR', payload)
    },
    toggleEditingBoxes (day, order) {
      this.editingDayOrder = order
      this.backupDay(day)
      this.scrollTo(order)
      this.toggleBox(true)
      this.loadDay(day, order)
    },
    cancelEditingBoxes (order) {
      this.restoreDay(order)
      this.isEditing = false
    },
    saveLikeATemplate (payload) {
      this.$emit('onSaveLikeATemplate', payload)
    },
    fillDay (payload) {
      this.$emit('onfillDay', payload)
    },
    deleteDay (payload) {
      this.$emit('onDeleteDay', payload)
      this.backupDay(payload.data)
    },
    reorderDay (payload) {
      this.$scrollTo('body', { duration: 800, offset: 120 })
      this.$emit('onReorderDay', payload)
    },
    slideDownDay () {
      this.isSlideDownDay = !this.isSlideDownDay
    },
    addDayAbove () {
      const payload = {
        index: this.order - 1,
        day: {
          id: null,
          title: 'Day added',
          locations: [],
          textday: '',
          startdate: this.data.startdate,
          startday: this.order - 1,
          isANewDay: true,
          image_duplicated: false,
          url_image: '',
          meals: [],
          duration: 1
        }
      }

      this.$store.commit('opportunity/TEMP_UPDATE_FROMITINERARY')
      this.$store.commit('opportunity/TEMP_ADD_DAY', payload)
      this.$store.commit('opportunity/TEMP_REFRESH_ORDER_DAYS', payload)
      this.$store.commit('opportunity/TEMP_REFRESH_DATE_DAYS', payload)

      this.scrollTo(this.order)
    },
    addDayBelow () {
      const payload = {
        index: this.order,
        day: {
          id: null,
          title: 'Day added',
          locations: [],
          textday: '',
          startdate: this.data.startdate,
          startday: this.order + 1,
          isANewDay: true,
          image_duplicated: false,
          url_image: '',
          meals: [],
          duration: 1
        }
      }

      this.$store.commit('opportunity/TEMP_ADD_DAY', payload)
      this.$store.commit('opportunity/TEMP_REFRESH_ORDER_DAYS', payload)
      this.$store.commit('opportunity/TEMP_REFRESH_DATE_DAYS', payload)

      const uuid = this.$route.params.privateId
      this.$store.dispatch('opportunity/saveOpportunityDataInLocalStorage', uuid)

      this.scrollTo(this.order)
    },
    async saveDay () {
      try {
        this.isSaving = true
        let dataChanged = this.itineraryDay
        if (
          Array.isArray(dataChanged.meals) &&
          dataChanged.meals.length === 0 &&
          Array.isArray(this.data.meals) &&
          this.data.meals.length > 0) {
          dataChanged.meals = this.data.meals
        }

        const startdate = this.data && this.data.startdate ? this.data.startdate : null
        this.$store.commit('opportunity/TEMP_SAVE_DAY', { ...dataChanged, startdate })

        const uuid = this.$route.params.privateId
        const response = await this.$store
          .dispatch('opportunity/saveOpportunityDataInLocalStorage', uuid)
        if (response) {
          this.isEditing = false
          this.isSaving = false
          this.$notification.success('Day was saved temporarily, when you finish editing the whole itinerary, please click the "Save" button located at the bottom.')
        }

        // this.$store
        //   .dispatch('opportunity/saveOpportunity')
        //   .then((response) => {
        //     const message = response.message
        //     this.$store
        //       .dispatch('opportunity/getOpportunity', response.data.uuidOpportunity)
        //       .then((response) => {
        //         this.$notification.success(message)
        //         this.isEditing = false
        //         this.isSaving = false
        //       })
        //       .catch(error => {
        //         this.isEditing = false
        //         this.isSaving = false
        //         if (error.response && error.response.status > 400) { // 401 || 403
        //           // this.$store.dispatch('auth/removeToken')
        //         }
        //       })
        //   })
        //   .catch(error => {
        //     console.log(error)
        //     this.isSearching = false
        //     this.isNotFound = true
        //   })
      } catch (error) {
        console.info(error)
        this.isSaving = false
        this.isSaving = false
      }
    },
    searchLocations (query) {
      const minLength = 4
      if (query !== '' && query.length >= minLength) {
        this.isLoading = true
        this.$store.dispatch('location/searchLocation', query)
          .then(response => {
            if (response && Array.isArray(response) && response.length > 0) {
              this.locations = response
            }
            this.isLoading = false
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
            this.locations = []
          })
      }
    },
    clearAll () {
      this.itineraryDay.locations = []
    },
    limitText (count) {
      return `and ${count} other locations`
    },
    addLocation (selectedOption, id) {
      const payload = {
        indexDay: this.editingDayOrder,
        locationId: selectedOption.id,
        name: selectedOption.name,
        order: selectedOption.order
      }
      this.$store.commit('opportunity/TEMP_ADD_LOCATION', payload)
    },
    removeLocation (removedOption, id) {
      const payload = {
        indexDay: this.editingDayOrder,
        locationId: removedOption.id
      }
      this.$store.commit('opportunity/TEMP_REMOVE_LOCATION', payload)
    },
    addMeal () {
      const payload = {
        indexDay: this.editingDayOrder
      }
      this.$store.commit('opportunity/TEMP_ADD_MEAL', payload)
    },
    removeMeal (meal, index) {
      const payload = {
        indexDay: this.editingDayOrder,
        mealId: meal,
        index: index
      }
      this.$el.querySelector(
        `#meal-${index}`
      ).setAttribute('style', 'background: rgba(217, 83, 79, 0.15) !important;')
      this.$store.commit('opportunity/TEMP_REMOVE_MEAL', payload)
    },
    saveUpdateMeal (e, meal, index) {
      const payload = {
        indexDay: this.editingDayOrder,
        mealId: meal,
        newValue: e.target.value,
        indexMeal: index
      }
      if (e.target.value === '') return this.removeMeal( meal, index); 
      this.$store.commit('opportunity/TEMP_UPDATE_MEAL', payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.kt-notes__item {
  padding-bottom: 0px !important;
  border-left: 1px solid #c1323e !important;
  padding-left: 0px !important;
  transition: all 0.4s ease-out;
  opacity: 1;
}
.kt-notes__item:last-child {
  border-left: none !important;
  opacity: 0;
}
.kt-notes__media {
  left: -16.5px !important;
}
.kt-notes__user {
  width: 30px !important;
  height: 30px !important;
  border: 30px !important;
}
.kt-notes__content {
  padding: 0.1rem !important;
  background-color: #ffffff !important;
  border-bottom: 1px solid #EDF1F7 !important;
  border-radius: 0 !important;
}
.kt-notes__item:last-child .kt-notes__content {
  border-bottom: none !important;
}
.kt-notes__content:after {
  border-right: solid 10px transparent !important;
}
.kt-notes__body {
  padding: .6rem 2rem !important;
  color: #032647 !important;
}
.kt-bg-danger {
  background-color: #c1323e !important;
}
@media (max-width: 575.98px) {
  .kt-notes__content {
    text-align: center;
  }
  .toolbar {
    position: inherit;
  }
}
.TabItineraryItem--group {
  position: absolute;
  top: 0;
  right: 3px;
}
.TabItineraryItem--edit {
  background: transparent;
  border-radius: 50%;
  padding: .3rem;
  border: 1.5px solid #c1323e;
  width: 30px;
  height: 30px;
  text-align: center;
}
.TabItineraryItem--edit.disabled {
  border-color: #999;
  color: #999 !important;
}
.lead {
  font-size: 13px;
  font-weight: 500;
}

.TabItineraryItem-locations {
  display: flex;
  align-items: center;
}

.TabItineraryItem-title,
.TabItineraryItem-locations,
.TabItineraryItem-textday,
.TabItineraryItem-accommodation {
  transition:
  background-color ease .3s,
  padding-top ease .3s,
  padding-bottom ease .3s,
  padding-left ease .3s;
}

.TabItineraryItem--edit:hover ~ div .TabItineraryItem-title,
.TabItineraryItem--edit:hover ~ h6 .TabItineraryItem-locations .TabItineraryItem-locations--tags,
.TabItineraryItem--edit:hover ~ div .TabItineraryItem-textday,
.TabItineraryItem--edit:hover ~ div .TabItineraryItem-textday,
.TabItineraryItem--edit:hover ~ div .TabItineraryItem-accommodation {
  background-color: #f3f7fa;
  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07);
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  cursor:pointer;
}

.TabItineraryItem-image .ImagePicker .ImagePicker-image {
  box-shadow: 0 0 1px #111;
  border: 3px solid #111;
}

.isANewDay {
  background: #ffc;
}

.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 300 !important;
  z-index: 2;
  font-size: 1rem;

}

.custom__tag {
  display: inline-block;
  padding: 3px 6px;
  background: rgba(0, 167, 203, 0.15);
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 1rem;
}

.custom__remove {
  padding: 0;
  font-size: 10px;
  margin-left: 5px
}
.multiselect__tags{
  font-size:1rem;
}
.multiselect__clear {
  position: absolute;
  right: 41px;
  height: 40px;
  width: 40px;
  display: block;
  cursor: pointer;
  z-index: 2;
  display:none;
}

.multiselect__clear:after,.multiselect__clear:before {
  content: "";
  display: block;
  position: absolute;
  width: 3px;
  height: 16px;
  background: #aaa;
  top: 12px;
  right: 4px
}

.multiselect__clear:before {
  transform: rotate(45deg)
}

.multiselect__clear:after {
  transform: rotate(-45deg)
}

.isANewDay-textday {
  height: 100px;
  font-size: 1.3rem;
  text-decoration: underline;
}

.slide-fade li {
  transition: all 0.4s ease-out;
  opacity: 0;
}
.slide-fade li.show {
  opacity: 1;
}

.kt-notes__item.slideDownDay {
  opacity: .5;
}
.dayItineraryAccommodation {
  width: 100%;
}
.disabledbtn {
  color: #999 !important;
}

.dayItineraryMeals>div {
  display: flex;
  align-items: center;
  margin-right: 10px;
  width: 30%;
}
.custom__remove,.custom__add {
  cursor: pointer;
}
.dayItineraryMeals {
  display: flex;
  flex-flow: row wrap;
}

.isHighlighted {
  background-color: #FFFACD;
}
</style>
